import React from "react";

export const About = (props) => {
  return (
    <div id="about">
       <br></br>
      <br></br>
      <br></br>
      <br></br>
      <div className="container">
        <div className="row">
         
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>About Us</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3>Why Choose Us?</h3>
              <p>{props.data ? props.data.Why : "loading..."}</p>
              <h3>IT Security</h3>
              <p>{props.data ? props.data.itSecurity : "loading..."}</p>

              {/* <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
          <div className="hidden-xs col-xs-12 col-md-6">
            <img src="img/about.png" alt="" />{" "}
          </div>
        </div>
      </div>
    </div>
  );
};
